import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { fetchChampionshipInfo } from 'modules/client/tournaments/store/client-tournament/actions';
import type { ClientTournamentSliceState } from './client-tournament-store';

type ReducerBuilder = ActionReducerMapBuilder<ClientTournamentSliceState>;

export function createFetchChampionshipInfoReducer(builder: ReducerBuilder) {
  builder.addCase(fetchChampionshipInfo.pending, (state) => {
    state.loading = true;
    state.loaded = false;
    state.error = null;
  });

  builder.addCase(fetchChampionshipInfo.fulfilled, (state, action) => {
    state.loading = false;
    state.loaded = true;
    state.error = null;

    state.teams = action.payload.teams;
    state.players = action.payload.players;
    state.stages = action.payload.stages;
    state.matches = action.payload.matches;
    state.championship = action.payload.championship;
  });

  builder.addCase(fetchChampionshipInfo.rejected, (state, action) => {
    state.loading = true;
    state.loaded = false;
    state.error = action.error.message || 'Unknown error';
  });
}
